<template>
  <el-row
    :span="24"
    style="margin-top: 10px"
    v-if="statusLogList && statusLogList.length > 0"
  >
    <div
      :class="`order-log ${item.flag ? 'order-red' : ''}`"
      v-for="item in statusLogList"
      :key="item.id"
    >
      <img
        v-if="item.flag"
        src="../../../assets/images/close-circle-fill@2x.png"
      />
      <img v-else src="../../../assets/images/check-circle-fill@2x.png" />
      <span class="order-log-date">{{ item.time }}</span>
      <span class=""
        >{{ item.creatorName || "--" }}({{ item.roles || "--" }})
        {{ item.statusOpt }}</span
      >
      <span
        class="exange-desc"
        v-if="item.reasonInfo && item.reasonInfo != 'undefined'"
        >，{{ item.reasonLabel }}{{ item.reasonInfo }}</span
      >
    </div>
  </el-row>
</template>

<script>
import { getDictMap } from "@/utils/util";
import dayjs from "dayjs";
export default {
  name: "editOrderLog",
  props: {
    afterSaleOrder: {
      type: Object,
    },
  },
  data() {
    return {
      statusLogList: [],
      dmap: {},
    };
  },
  watch: {
    afterSaleOrder(newval) {
      this.updateStatusLog(newval);
    },
  },
  mounted() {
    this.dmap = getDictMap();
    this.updateStatusLog(this.afterSaleOrder);
  },
  methods: {
    updateStatusLog(data) {
      console.log("editOrderLog:-------------------", data);

      this.statusLogList = (data?.statusLog || []).map((l) => {
        const sf = this.dmap[l.statusFrom];
        const st = this.dmap[l.statusTo];
        let statusOpt = sf?.name;
        let reasonLabel, reasonInfo;
        let flag = false;
        if (sf?.code === "pre_inspection_of_receiving_goods") {
          const ass = this.dmap[l.afterSalesSolution];
          if (ass?.code === "repair") {
            statusOpt = `确认${ass?.name || ""}`;
          } else if (ass?.code === "exchange_goods") {
            statusOpt = `提交${ass?.name || ""}`;
            reasonLabel = "换货说明：";
            reasonInfo = l.description;
          } else if (ass?.code === "goods_return") {
            statusOpt = `操作${ass?.name || ""}`;
            reasonLabel = "原因：";
            reasonInfo = l.description;
          } else if (["cancelled"].includes(st?.code)) {
            statusOpt = st?.name + "售后单";
            reasonLabel = "原因：";
            reasonInfo =
              this.dmap[l.reason]?.name +
              (l.description ? "：" + l.description : "");
          } else if (ass?.code === "reject_return") {
            statusOpt = ass?.name;
            reasonLabel = "原因：";
            reasonInfo =
              (this.dmap[l.reason]?.name || "") +
              (l.description ? "：" + l.description : "");
            flag = true;
          } else {
            statusOpt = ass?.name;
          }
        } else if (sf?.code === "pending_review") {
          if (st?.code === "to_be_sent_out") {
            statusOpt = "审批通过";
          } else {
            statusOpt = "审批拒绝";
            reasonLabel = "拒绝原因：";
            reasonInfo =
              this.dmap[l.reason]?.name +
              (l.description ? "：" + l.description : "");
            flag = true;
          }
        } else if (
          ["to_be_returned", "to_be_sent_out", "under_repair"].includes(
            sf?.code
          )
        ) {
          statusOpt = st?.name + "设备";
        }
        return {
          ...l,
          time: dayjs(l.createdAt).format("YYYY.MM.DD HH:mm"),
          statusOpt,
          reasonLabel,
          reasonInfo,
          flag,
        };
      });
      console.log(this.statusLogList, "---------------------------------");
    },
  },
};
</script>

<style lang="less" scoped>
.order-log {
  display: flex;
  align-items: center;
  border-radius: 2px;
  margin-bottom: 10px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  background-color: #e8ffea;
  padding: 10px 16px;
  box-sizing: border-box;
  .order-log-date {
    margin-right: 10px;
  }
}
.order-red {
  background-color: #ffece8;
}
</style>
